module.exports = __webpack_public_path__ + "img/promote-wellness-depth1.f54bceac.png";